export default __webpack_public_path__ + "static/media/a016-5.629c836d.png";